import { render, staticRenderFns } from "./Propulsion.vue?vue&type=template&id=3a649bf0&scoped=true&"
import script from "./Propulsion.vue?vue&type=script&lang=js&"
export * from "./Propulsion.vue?vue&type=script&lang=js&"
import style0 from "./Propulsion.vue?vue&type=style&index=0&id=3a649bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a649bf0",
  null
  
)

export default component.exports